const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const photosApi = {
  list:        (opts)        => request('/photos',                { query: opts }),
  get:         (id)          => request(`/photos/${id}`),
  adminList:   (token, opts) => request('/admin/photos',          { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/photos/${id}`,    { token }),
  adminCreate: (token, body) => request('/admin/photos',          { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/photos/${id}`,    { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/photos/${id}`,    { method: 'DELETE', token }),
};

export const PHOTO_CATEGORIES = [
  { id: 'all',         lbl: 'Tout' },
  { id: 'drone',       lbl: 'Drone' },
  { id: 'plage',       lbl: 'Plage' },
  { id: 'ceremonies',  lbl: 'Cérémonies' },
  { id: 'sport',       lbl: 'Sport · ASC' },
  { id: 'portraits',   lbl: 'Portraits' },
  { id: 'quotidien',   lbl: 'Quotidien' },
  { id: 'architecture',lbl: 'Architecture' },
];

export const PHOTO_SIZES = ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'];

export const CATEGORY_LABEL = Object.fromEntries(PHOTO_CATEGORIES.map((c) => [c.id, c.lbl]));
